'use client';import React from 'react';
import PageBanner from '../components/PageBanner';
import bannerImage from '../assets/legal/privacy_banner.webp';

const PrivacyPolicy = () => {
    return (
        <>
            <PageBanner
                title="Privacy Policy"
                description="Your privacy is important to us. This policy explains how we collect, use, and protect your personal information."
                bgColor="#ECFDF5"
                blobColors={["#34D399", "#2DD4BF", "#6EE7B7"]}
            />

            <div className="container container-prose py-20">
                <div className="max-w-3xl mx-auto">
                    <p className="text-md text-gray-500 mb-10">Last updated: {new Date().toLocaleDateString()}</p>

                    <div className="space-y-12">
                        <section>
                            <h2 className="text-display-xs font-semibold mb-4 text-gray-900">1. Information We Collect</h2>
                            <p className="text-lg text-gray-600 leading-relaxed">
                                We collect information you provide directly to us, such as when you create an account, update your profile, or use our interactive features. This may include your name, email address, professional history, and other information you choose to provide.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-display-xs font-semibold mb-4 text-gray-900">2. How We Use Your Information</h2>
                            <p className="text-lg text-gray-600 leading-relaxed">
                                We use the information we collect to provide, maintain, and improve our services, to develop new ones, and to protect Exibell and our users. This includes personalizing your experience and providing AI-driven career insights.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-display-xs font-semibold mb-4 text-gray-900">3. Data Security</h2>
                            <p className="text-lg text-gray-600 leading-relaxed">
                                We use reasonable security measures to help protect information about you from loss, theft, misuse and unauthorized access, disclosure, alteration and destruction. We employ industry-standard encryption and security protocols.
                            </p>
                        </section>
                    </div>

                    <div className="mt-16 pt-8 border-t border-gray-100">
                        <p className="text-gray-500 italic">This is a summary of our full Privacy Policy. For detailed information, please contact our legal team.</p>
                    </div>
                </div>
            </div>
        </>
    );
};

export default PrivacyPolicy;
